/**
 * HTTP layer for relay-controller measurements. Reads a device's recorded
 * measurement series.
 *
 * Contains:
 * - fetchMeasurements: a relay controller's measurements
 */
/*
GET /api/relaycontrollers/{relay_controller_id}/measurements/
GET /api/relaycontrollers/{relay_controller_id}/measurements/{measurement_id}/
*/
import apiClient from '@sophocles/http-common';

export const fetchMeasurements = (relayControllerId, queryParams) =>
  apiClient.get(`/relaycontrollers/${relayControllerId}/measurements/`, { params: queryParams }).then(res => res.data);
